import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthenticationService } from 'src/app/root/_services/authentication.service';
import { StorageService } from 'src/app/root/_services/storage.service';
import { containsInArray } from '../_utils/general-util';
import { TranslateService } from '@ngx-translate/core';
import * as i0 from "@angular/core";
import * as i1 from "@ngx-translate/core";
import * as i2 from "@angular/router";
import * as i3 from "../../root/_services/authentication.service";
import * as i4 from "../../root/_services/storage.service";
var AuthGuard = /** @class */ (function () {
    function AuthGuard(translateService, router, authService, storageService) {
        this.translateService = translateService;
        this.router = router;
        this.authService = authService;
        this.storageService = storageService;
        this.jwtHelper = new JwtHelperService();
    }
    AuthGuard.prototype.canActivate = function (next, state) {
        var _this = this;
        //const currentUser = this.storageService.getItem('current_user');
        var token = this.storageService.getItemPlain('access_token');
        var lingua = this.storageService.getItemPlain('language');
        if (lingua)
            this.translateService.use(lingua);
        var currentUser = null;
        if (token)
            currentUser = this.jwtHelper.decodeToken(token).user;
        if (currentUser) {
            // check if route is restricted by role
            //if (next.data.roles && next.data.roles.indexOf(currentUser.profilo) === -1) {
            // role not authorised so redirect to home page
            //this.router.navigate([next.data.noAuthRedirect]);
            //return false;
            //}
            if (next.data.roles && !containsInArray(next.data.roles, currentUser.auth_profilo)) {
                this.authService.logout(false)
                    .subscribe(function (data) {
                    _this.router.navigate(['/login']);
                    _this.authService.clearClientSession();
                }, function (error) {
                    _this.router.navigate(['/login']);
                    _this.authService.clearClientSession();
                });
                return false;
            }
            else if (currentUser.auth_profilo == "P" && !next.data.is_wizard && !currentUser.profilo_valido) {
                this.router.navigate(['/wizard']);
                return false;
            }
            // authorised so return true
            return true;
        }
        // not logged in so redirect to login page with the return url
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
    };
    AuthGuard.ngInjectableDef = i0.defineInjectable({ factory: function AuthGuard_Factory() { return new AuthGuard(i0.inject(i1.TranslateService), i0.inject(i2.Router), i0.inject(i3.AuthenticationService), i0.inject(i4.StorageService)); }, token: AuthGuard, providedIn: "root" });
    return AuthGuard;
}());
export { AuthGuard };
